import React from "react";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getCloudDocumentAction, uploadFileDeck } from "./actions";
import { Row, Col, Tabs } from 'antd';
import { useState } from "react";
import FundDeck from "@hedgefund/shared/src/FundDeck";
import { Button, Spinner, Input } from "@public/ui-toolkit";
import { useFormik } from "formik";
import * as Yup from "yup";
import { alertService } from "@hedgefund/shared/src/Alert";
import ReactModal from "@public/ui-toolkit/src/ReactModal";
import Select from "react-select";
const CloudDocuments = [
  {
    name: "All Document",
    key: null
  },
  {
    name: "Presentation",
    key: 0
  },
  {
    name: "Investor Letters",
    key: 1
  },
  {
    name: "Firm Research",
    key: 2
  },
  {
    name: "Due Diligence Document",
    key: 3
  }
]
const CloudDocumentDropdown = [
  {
    name: "Presentation",
    key: 0
  },
  {
    name: "Investor Letters",
    key: 1
  },
  {
    name: "Firm Research",
    key: 2
  },
  {
    name: "Due Diligence Document",
    key: 3
  }
]
const customStyles = {
  control: (provided, state) => ({
    ...provided,
    border: "1px solid #212529",
    padding: 4,
  }),
  option: (base, state) => ({
    ...base,
    height: "100%",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#000",
  }),
  singleValue: (provided) => ({ ...provided, color: "#000" }),
  input: (styles) => ({ ...styles, color: "#000" }),
};
const CloudDocument = ({ match }) => {
  const [activeTab, setActiveTab] = useState();
  const [open, setOpen] = useState(false);

  const getCloudDocumentState = useSelector((state) => state.CloudDocumentStore);
  const { loading, getDocuments, fileDeckLoading } = getCloudDocumentState;
  const dispatch = useDispatch();
  const hedgeFundId = match.params.id;
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => {
    setOpen(false);
  }

  useEffect(() => {
    getCloudDocuments(null);
  }, []);

  const getCloudDocuments = (DocType) => {
    dispatch(getCloudDocumentAction({
      recordId: hedgeFundId,
      recordType: 1,
      docType: DocType
    }));
  }
  const onClickTab = (tabId) => {
    getCloudDocuments(tabId);
    setActiveTab(tabId);
  }

  const onSuccessAlert = () => {
    alertService.success("Successfully uploaded!", { autoClose: true });
  };

  const formik = useFormik({
    initialValues: {
      file: "",
      recordId: "",
      docType: "",
    },
    validationSchema: Yup.object({
      docType: Yup.string().required("Document Type is required"),
      file: Yup.string().required("File Deck is required"),
    }),
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append(`Url`, values.file);
      formData.append(`RecordId`, hedgeFundId);
      formData.append(`DocType`, values.docType);
      uploadFundDeck(formData);
    },
  });
  const uploadFundDeck = (values) => {
    dispatch(uploadFileDeck(values, onSuccessAlert, onCloseModal));
  };

  return (
    <main className="main-doc">
      <div className="main-inner">
        {!loading ? (
          <div className="container mt-5">
            <div>
              <Row className="border"
                style={{
                  background: "#ffff",
                  padding: "10px",
                  borderRadius: "10px",
                  width: "100%",
                }}>
                <Col span={19} >
                  <div className="Fund-FontSize" style={{ fontSize: "20px", padding: "10px" }}>Fund Document Cloud</div>
                </Col>
                <Col span={5} >
                  <Row style={{ justifyContent: "end" }}>
                    <Button
                      btnName="Upload Pdf"
                      btnType="!primary"
                      iconClass="fa fa-download mr-2"
                      onClick={onOpenModal}
                      type="button"
                    />
                    <ReactModal open={open} onClose={onCloseModal} center title={"Upload File Deck"} >
                      <form onSubmit={formik.handleSubmit}>
                        <div className="modal-body">
                          <Row gutter={[12, 12]}>
                            <Col span={24}>
                              <Select
                                styles={customStyles}
                                defaultValue={"Select Document Type"}
                                onChange={(e) => {
                                  formik.setFieldValue("docType", e.value)
                                }}
                                options={CloudDocumentDropdown.map((item) => {
                                  return {
                                    value: item?.key,
                                    label: item?.name,
                                  };
                                })}
                              />
                              {formik.touched.docType &&
                                formik.errors.docType ? (
                                <div className="form-error-message">
                                  {formik.errors.docType}
                                </div>
                              ) : null}
                            </Col>
                            <Col span={24}>
                              <Input
                                type="file"
                                id="file"
                                name="file"
                                onChange={(e) =>
                                  formik.setFieldValue("file", e.target.files[0])
                                }
                                accept=".pdf"
                              />
                              {formik.touched.file &&
                                formik.errors.file ? (
                                <div className="form-error-message">
                                  {formik.errors.file}
                                </div>
                              ) : null}
                            </Col>
                          </Row>
                        </div>
                        <div className="modal-footer d-block text-center">
                          <Button
                            btnName="Upload"
                            btnType="primary"
                            loading={fileDeckLoading}
                            type="submit"
                          />
                        </div>
                      </form>
                    </ReactModal>
                  </Row>
                </Col>
                <Col span={24}>
                <Tabs
                  activeKey={activeTab}
                  className="custom-tabs"
                  size="large"
                  onTabClick={(e) => onClickTab(e)}
                  type="card"
                  items={CloudDocuments?.map((item, index) => {
                    return {
                      label: item.name,
                      key: item.key,
                      children:
                          <FundDeck
                            portal="hedgefund"
                            decks={getDocuments}
                          />
                    };
                  })}
                />
                </Col>
              </Row>
            </div>
          </div>
        ) : (
          <Spinner />
        )}
      </div>
    </main>
  );
};

export default CloudDocument;
